<template>
  <vs-popup :active.sync="isActive" v-if="newCategory != null" id="newProductCategoryAdd" v-esc="escape"
    :title="newCategory.id != null ? 'Kategori Düzenle' : rootCategory != null ? rootCategory.name + ' Altına Kategori Ekle' : 'Ana Kategoriye Yeni Kategori Ekle'">
    <vs-row vs-type="flex" vs-w="12">
      <vs-col id="newProductCategoryDetailSide" vs-type="block" vs-w="5" class="pr-5">
        <vs-row vs-type="flex" vs-w="12">
          <vs-row v-if="newCategory.imageUrl" vs-type="flex" vs-w="12">
            <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
              <div class="w-full mx-auto sale-box-shadow low-border-radius flex items-center justify-center">
                <img v-if="!needUpload" :src="$baseUrl + '/' + newCategory.imageUrl" alt="img" class="responsive py-2"
                  style="max-width:120px;">
                <img v-if="needUpload" :src="newCategory.imageUrl" alt="img" class="responsive py-2"
                  style="max-width:120px;">
              </div>
            </vs-row>
            <div class="modify-img flex justify-between mt-2">
              <input type="file" class="hidden" ref="updateImgInput" @change="updateCurrImg" accept="image/*">
              <vs-button color="primary" class="w-full" @click="$refs.updateImgInput.click()">Fotoğrafı Güncelle
              </vs-button>
            </div>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="upload-img" v-if="!newCategory.imageUrl">
            <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" accept="image/*">
            <vs-button class="w-full" icon-pack="feather" icon="icon-arrow-up" @click="$refs.uploadImgInput.click()">
              Fotoğraf Yükle</vs-button>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-2">
            <vs-input id="name" name="İsim" v-validate="'required|min:2|max:60'" v-model="newCategory.name"
              class="w-full" placeholder="İsim" />
            <span class="text-danger text-xsmaller" v-show="errors.has('İsim')">{{ errors.first("İsim")}}</span>
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-2">
            <vs-input-number min="0" :max="rootCategory.childCategories.length" color="primary"
              class="categoryIndexer w-full m-0" v-model="newCategory.index" label="Sıra Numarası" />
          </vs-row>
          <vs-row vs-type="flex" vs-w="12" class="mt-2">
            <vs-textarea id="description" name="Açıklama" v-model="newCategory.description" class="w-full pb-0 mb-0"
              label="Açıklama" />
          </vs-row>
        </vs-row>
      </vs-col>
      <div id="newProductCategoryIndexSide" class="pl-2 py-1" v-w-auto-full>
        <vs-list>
          <vs-list-item class="px-4" :class="{'newProductCategoryItem' : category.id == null || category.id == newCategory.id}"
            :title="(category.index == null ? 'Belirsiz' : category.index) + ' - ' + (category.name == null || category.name == '' || category.name == 'undefined' ? 'YENİ*' : category.name)"
            :subtitle="category.description" v-for="(category,index) in orderedCategories" :key="index"></vs-list-item>
        </vs-list>
      </div>
      <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="space-between" class="mt-2">
        <vs-col vs-type="flex" class="w-auto">
          <vs-button @click="closePopup" color="danger" icon-pack="feather" icon="icon-arrow-left">
            Vazgeç
          </vs-button>
        </vs-col>
        <vs-col vs-type="flex" class="w-auto">
          <vs-button @click="submitData" type="gradient" color="success" icon-pack="feather" icon="icon-save">
            Kaydet
          </vs-button>
        </vs-col>
      </vs-row>
    </vs-row>
  </vs-popup>
</template>

<script>
  import {
    uploadImage,
    createNewProductCategory,
    updateProductCategory,
  } from "@/api/ProductCategory.js";
  export default {
    data() {
      return {
        isActive: false,
        newCategory: null,
        needUpload: false,
        rootCategory: null,
        categoryPhotoBinary: ""
      }
    },
    methods: {
      closePopup() {
        this.$nextTick(() => {
          this.escape();
        })
      },
      updateCurrImg(input) {
        this.needUpload = true;
        if (input.target.files && input.target.files[0]) {
          var reader = new FileReader()
          reader.onload = e => {
            this.newCategory.imageUrl = e.target.result
          }
          reader.readAsDataURL(input.target.files[0])
          this.categoryPhotoBinary = input.target.files[0];
        }
      },
      escape() {
        if (this.isActive == true) this.isActive = false;
      },
      submitData: async function () {
        let checker;
        checker = await this.$validator.validateAll();
        if (checker) {
          if (this.newCategory.imageUrl !== null && this
            .needUpload === true) {
            await this.uploadImage();
          } else if (this.newCategory.imageUrl == null || this.newCategory.imageUrl == "") {
            this.$vs.notify({
              color: "danger",
              title: "Hata ",
              text: "Fotoğraf Seçmeniz Gerekiyor !"
            });
            return;
          }
          if (this.newCategory.id != null) {
            updateProductCategory(this.newCategory).then(res => {
              if (res && res.status == 200) {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Kategori Güncelleme Başarılı !"
                });
                this.$validator.reset();
                this.isActive = false;
                this.$emit("saveChanges", this.rootCategory);
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Kategori Güncelleme Başarısız !"
                });
              }
            }).catch(err => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası ! "
              });
            });
          } else {
            this.newCategory.id = 0;
            createNewProductCategory(this.newCategory).then(res => {
              if (res && res.status == 200) {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı",
                  text: "Ürün Ekleme Başarılı !"
                });
                this.$validator.reset();
                this.isActive = false;
                this.newCategory.id = res.data.id
                this.$emit("saveChanges", this.rootCategory);
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Ürün Ekleme Başarısız !"
                });
              }
            }).catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !"
              });
            });
          }
        }
      },
      uploadImage: async function () {
        let image = this.categoryPhotoBinary;
        let formData = new FormData();
        formData.append("image", image);
        await uploadImage(formData).then(res => {
          if (res && res.status == 200) {
            this.newCategory.imageUrl = "StaticFiles/images/" + res.data;
            this.needUpload = false;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Seçilen Fotoğraf Yüklenemedi !"
            });
          }
        }).catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
    },
    computed: {
      orderedCategories() {
        return this.rootCategory.childCategories.sort(function (a, b) {
          if (a.index > b.index) return 1;
          else if (a.index < b.index) return -1;
          else {
            if (a.name > b.name) return 1;
            else if (a.name < b.name) return -1;
            else return 0;
          }
        });
      }
    }
  }

</script>

<style>
  #newProductCategoryDetailSide {
    border-right: 1px solid #00000020;
  }

  .categoryIndexer span {
    font-size: .8rem;
  }

  .categoryIndexer input {
    font-size: .9rem;
    color: rgba(var(--vs-primary), 1);
    font-weight: bold;
  }

  #newProductCategoryIndexSide .vs-list--title {
    font-size: .8rem;
    font-weight: 600;
  }

  #newProductCategoryIndexSide .vs-list {
    overflow: auto;
    max-height: 48vh;
  }

  #newProductCategoryIndexSide .newProductCategoryItem {
    background-color: rgba(var(--vs-primary), 1);
    border-radius: 7px;
    color: white;
  }

</style>
